import { h, defineComponent } from "vue";
import FluteFingering from "./FluteFingering.vue";

/**
 * Wrapper component for FluteFingering that accepts simple string props
 * from markdown inline syntax and converts them to the proper format.
 *
 * Usage in markdown:
 * {{ <fluteFingering note="C4" fingering="l1,l2,l3,r1,r2,r3" width="300" /> }}
 *
 * Fingering format options:
 * - Comma-separated keys: "l1,l2,l3,r1,r2,r3"
 * - With state values: "l1:1,l2:0.5,r1:1"
 * - JSON string: '{"l1":1,"l2":1,"r3":1}'
 */
export default defineComponent({
  name: "FluteFingeringInline",
  props: {
    note: {
      type: String,
      default: undefined,
    },
    fingering: {
      type: String,
      default: undefined,
    },
    width: {
      type: String,
      default: undefined,
    },
    height: {
      type: String,
      default: undefined,
    },
  },
  render() {
    console.log("[FluteFingeringInline] Rendering with props:", {
      note: this.note,
      fingering: this.fingering,
      width: this.width,
      height: this.height,
    });

    try {
      const fingeringObj: any = {};

      if (this.fingering) {
        // Try JSON parse first
        if (this.fingering.startsWith("{")) {
          try {
            Object.assign(fingeringObj, JSON.parse(this.fingering));
          } catch (e) {
            console.warn(
              "[FluteFingeringInline] Failed to parse fingering JSON:",
              e,
            );
          }
        } else {
          // Parse comma-separated format
          const parts = this.fingering.split(",").map((s) => s.trim());
          for (const part of parts) {
            if (part.includes(":")) {
              // Format: "l1:1,l2:0.5"
              const [key, value] = part.split(":");
              fingeringObj[key.trim()] = parseFloat(value.trim());
            } else {
              // Format: "l1,l2,l3" (defaults to 1 = closed)
              fingeringObj[part] = 1;
            }
          }
        }
      }

      const componentProps: any = {
        note: this.note,
        fingering: fingeringObj,
      };

      if (this.width) {
        componentProps.width = parseInt(this.width);
      }
      if (this.height) {
        componentProps.height = parseInt(this.height);
      }

      console.log("[FluteFingeringInline] Parsed fingering:", fingeringObj);
      console.log("[FluteFingeringInline] Component props:", componentProps);

      return h(
        "span",
        {
          style:
            "display: inline-block; vertical-align: middle; margin: 0 4px;",
        },
        [h(FluteFingering, componentProps)],
      );
    } catch (error) {
      console.error("[FluteFingeringInline] Render error:", error);
      return h(
        "span",
        {
          style:
            "color: red; border: 1px solid red; padding: 4px; display: inline-block;",
        },
        `[FluteFingering Error: ${error}]`,
      );
    }
  },
});
